import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loadable } from '../../types';
import {
  ApplicationType,
  CurrentApplicationContext,
} from '../../services/contexts/CurrentApplicationContext';
import { endorsementApi } from '../../httpclient';

type ProviderProps = {
  paramKey?: string;
  children?: any;
};

export const CurrentApplicationProvider: React.FC<ProviderProps> = ({
  children,
  paramKey = 'applicationUid',
}) => {
  const applicationUid = useParams()[paramKey];
  const currentAppId = useRef<string>(applicationUid || '');
  const [application, setApplication] = useState<Loadable<ApplicationType>>({});

  const loadCurrentApplication = useCallback(() => {
    const idToLoad = currentAppId.current;
    if (!idToLoad) return;
    setApplication({ loading: true });
    endorsementApi
      .getApplicationGroupById(idToLoad)
      .then((r) => {
        if (idToLoad === currentAppId.current) {
          setApplication({ result: r?.data as ApplicationType });
        }
      })
      .catch((e) => {
        if (idToLoad === currentAppId.current) {
          setApplication({ error: e });
        }
      });
  }, []);

  useEffect(() => {
    currentAppId.current = applicationUid || '';
    loadCurrentApplication();
  }, [applicationUid, loadCurrentApplication]);

  const value = {
    application,
    refresh: loadCurrentApplication,
    setApplication,
  };

  return (
    <CurrentApplicationContext.Provider value={value}>
      {children}
    </CurrentApplicationContext.Provider>
  );
};
